import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  // isAuthenticated,
  // setAuthentication,
  logout,
} from "../../../helper/auth";

import { checkAuth } from "../../../api/auth";

interface AuthState {
  isAuthenticated: boolean;
  token: string | null;
  user: any | null;
  userType: string | null;
  isUserLoaded: boolean;
}

const initialState: AuthState = {
  isAuthenticated: false,
  token: null,
  user: {
    permissions: [],
  },
  userType: null,
  isUserLoaded: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setLogin: (state, action) => {
      state.isAuthenticated = true;
      state.isUserLoaded = true;
      state.user = { ...action.payload?.user, password: undefined };
      state.userType = action.payload?.userType;
      // setAuthentication(action.payload.user);
    },
    loadUserData: (state, action) => {
      state.isAuthenticated = true;
      state.user = { ...action.payload, password: undefined };
      state.userType = action.payload?.userType;
      state.isUserLoaded = true;
    },
    setLogout: (state) => {
      state = initialState;
      // console.log("DECONNECTION !!!")
      logout();
    },
    setUserLoading: (state, action) => {
      state.isUserLoaded = action.payload; // true ou false
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadUserDataThunk.pending, (state) => {
        // Optionally handle loading state
      })
      .addCase(loadUserDataThunk.fulfilled, (state, action) => {
        state.isUserLoaded = true;
        state.isAuthenticated = true;
        state.user = { ...action.payload.user, password: undefined };
        state.userType = action.payload.userType;
      })
      .addCase(loadUserDataThunk.rejected, (state, action) => {
        // console.error("Failed to load user data:", action.payload);
        logout(); // Supprime le token, etc.
        return {
          ...initialState,
          isUserLoaded: true, // ✅ ➜ indique qu'on a fini de charger (même si c'est un échec)
        };
      });
  },
});

export const loadUserDataThunk = createAsyncThunk(
  "auth/loadUserData",
  async (_, thunkAPI) => {
    try {
      const userData = await checkAuth();
      // console.log("user data", userData);
      return userData;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const { setLogin, loadUserData, setLogout, setUserLoading } =
  authSlice.actions;

export default authSlice.reducer;
